import { render, staticRenderFns } from "./TftUiBracketNode.vue?vue&type=template&id=2bb4353a"
import script from "./TftUiBracketNode.vue?vue&type=script&lang=js"
export * from "./TftUiBracketNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports